module.exports = "images/8ans.bc224224.png";